import { CampaignObjectiveType } from "@ad/tt_ads_common_enums";

export const TEA_EVENT = {
  SHOW_MEDIA_PAGE: 'ml_ads_creation_media_show',
  SHOW_OBJECTIVE_PAGE: 'ml_ads_creation_objective_show',
  [`${CampaignObjectiveType.TRAFFIC}_SHOW`]: 'ml_ads_creation_traffic_show',
  [`${CampaignObjectiveType.TRAFFIC}_CLICK`]: 'ml_ads_creation_traffic_click',
  [`${CampaignObjectiveType.ENGAGEMENT}_SHOW`]: 'ml_ads_creation_engagement_show',
  [`${CampaignObjectiveType.ENGAGEMENT}_CLICK`]: 'ml_ads_creation_engagement_click',
  [`${CampaignObjectiveType.LEADADS}_SHOW`]: 'ml_ads_creation_lead_gen_show',
  [`${CampaignObjectiveType.LEADADS}_CLICK`]: 'ml_ads_creation_lead_gen_click',
  CONTINUE: 'ml_ads_creation_continue_click',
  SHOW_AD_DETAILS_PAGE: 'ml_ads_creation_ad_show',
  USER_CLICK_TIKTOK_POST_BUTTON: 'ml_ads_creation_ad_ttpost_click',
  USER_CHOOSE_TIKTOK_POST: 'ml_ads_creation_ttpost_choose_click',
  DISPLAY_TIKTOK_PAGE: 'ml_ads_creation_ttpost_show',
  USER_OPEN_TIKTOK_ACCOUNT_SELECTION: 'ml_ads_creation_ttpost_account_click',
  USER_SELECT_A_TIKTOK_ACCOUNT: 'ml_ads_creation_ttpost_account_choose_click',
  USER_CLICK_LINK_TIKTOK_ACCOUNT: 'ml_ads_creation_ttpost_account_link_click',
  USER_CHOOSE_TO_CREATE_NEW_VIDEO: 'ml_ads_creation_ad_video_click',
  DISPLAY_VIDEO_LIBRARY: 'ml_ads_creation_video_library_show',
  USER_CHOOSE_A_VIDEO_FROM_LIBRARY: 'ml_ads_creation_video_library_choose_video_click',
  USER_CHOOSE_UPLOAD_A_VIDEO: 'ml_ads_creation_video_upload_click',
  USER_CLICK_CONTINUE_TO_UPLOAD_VIDEO: 'ml_ads_creation_video_upload_continue_click',
  USER_CLICK_CREATE_VIDEO_FROM_IMAGE: 'ml_ads_creation_video_from_image_click',
  USER_IN_UPLOAD_IMAGE_WINDOW: 'ml_ads_creation_video_from_image_uploadnow_click',
  USER_START_CREATE_VIDEO_BY_IMAGE: 'ml_ads_creation_video_from_image_createvideo_click',
  USER_ENTER_AD_TEXT: 'ml_ads_creation_ad_text_click',
  USER_CLICK_CTA: 'ml_ads_creation_CTA_click',
  USER_ENTER_URL: 'ml_ads_creation_url_click',
  USER_UPLOAD_AVATAR: 'ml_ads_creation_profile_image_click',
  USER_UPDATE_PROFILE_NAME: 'ml_ads_creation_profile_name_click',
  USER_SWITCH_TO_TIKTOK_ACCOUNT: 'ml_ads_creation_ttprofile_click',
  USER_SWITCH_TO_CUSTOM_ACCOUNT: 'ml_ads_creation_custom_profile_click',
  USER_CLICK_DISCLAIMER: 'ml_ads_creation_ad_disclaimer_click',
  USER_CLICK_DROPDOWN_LIST_LEAD_GEN: 'ml_ads_creation_instant_form_click',
  USER_CLICK_SPECIFIC_LEAD_GEN_FORM: 'ml_ads_creation_instant_form_choose_click',
  USER_CREATE_NEW_FORM: 'ml_ads_creation_instant_form_create_click',
  DISPLAY_AUDIENCE_PAGE: 'ml_ads_creation_audience_show',
  USER_CLICK_CUSTOM_AUDIENCE: 'ml_ads_creation_custom_targeting_click',
  USER_CLICK_AUTO_TARGET: 'ml_ads_creation_auto_targeting_click',
  USER_CLICK_LOCATION_ON_TARGET: 'ml_ads_creation_location_click',
  DISPLAY_LOCATION_PAGE: 'ml_ads_creation_location_popup_show',
  USER_SEARCH_ON_LOCATION: 'ml_ads_creation_location_search_click',
  USER_CONFIRM_LOCATION: 'ml_ads_creation_location_done_click',
  USER_CLICK_LANGUAGE_DROPDOWN: 'ml_ads_creation_demographics_language_click',
  DISPLAY_LANGUAGE_POPUP: 'ml_ads_creation_language_popup_click',
  USER_CLICK_SEARCH_BOX_ON_LANGUAGE: 'ml_ads_creation_language_search_click',
  USER_CONFIRM_LANGUAGE: 'ml_ads_creation_language_done_click',
  USER_CLICK_INTEREST_ON_TARGET: 'ml_ads_creation_interests_click',
  DISPLAY_INTEREST_PAGE: 'ml_ads_creation_interests_popup_show',
  USER_SEARCH_ON_INTEREST: 'ml_ads_creation_interests_search_click',
  USER_CONFIRM_INTEREST: 'ml_ads_creation_interests_done_click',
  USER_CLICK_SHOW_MORE: 'ml_ads_creation_placements_showmore_click',
  USER_CLICK_SHOW_LESS: 'ml_ads_creation_placements_showless_click',
  USER_CLICK_TIKTOK_OR_PANGLE: 'ml_ads_creation_placements_click',
  USER_CLICK_DEMOGRAPHICS: 'ml_ads_creation_demographics_click',
  USER_CONFIRM_DEMOGRAPHICS: 'ml_ads_creation_demographics_done_click',
  DISPLAY_DEMOGRAPHICS: 'ml_ads_creation_demographics_popup_show',
  USER_CLICK_GENDER: 'ml_ads_creation_demographics_gender_click',
  USER_CLICK_AGE: 'ml_ads_creation_demographics_age_click',
  DISPLAY_BUDGET: 'ml_ads_creation_budget_show',
  USER_SWITCH_DAILY_LIFETIME: 'ml_ads_creation_budget_mode_click',
  USER_SELECT_DAILY: 'ml_ads_creation_budget_daily_click',
  USER_SELECT_LIFETIME: 'ml_ads_creation_budget_daily_click',
  USER_INPUT_BUDGET: 'ml_ads_creation_budget_enter_click',
  USER_CLICK_BUDGET_GOAL_SELECTION_BUTTON: 'ml_ads_creation_engagement_budget_goal_click',
  USER_CLICK_ON_BUDGET_GOAL: 'ml_ads_creation_engagement_budget_goal_choose_click',
  USER_CLICK_SET_DATE_OPTION: 'ml_ads_creation_schedule_set_dates_click',
  USER_CLICK_START_NOW_NO_END_DATE: 'ml_ads_creation_schedule_run_continuously_click',
  USER_CLICK_START_TIME: 'ml_ads_creation_schedule_set_dates_start_click',
  USER_CLICK_END_TIME: 'ml_ads_creation_schedule_set_dates_end_click',
  DISPLAY_START_TIME_POP: 'ml_ads_creation_schedule_set_dates_start_popup_show',
  DISPLAY_END_TIME_POP: 'ml_ads_creation_schedule_set_dates_end_popup_show',
  USER_CONFIRM_START_TIME: 'ml_ads_creation_schedule_set_dates_start_done_click',
  USER_CONFIRM_END_TIME: 'ml_ads_creation_schedule_set_dates_end_done_click',
  USER_CLICK_PUBLISH: 'ml_ads_creation_publish_click',
  SUCCESS_PUBLISH: 'ml_ads_creation_publish_click_result'
};
export const TEA_TRACKING_CAMPAIGN = {
  ADD_TO_HOME_SCREEN_SHOW: 'add_to_homescreen_show',
  ADD_TO_HOME_SCREEN_CLICK: 'add_to_home_screen_click',
  ADD_TO_HOME_SCREEN_USER_CLOSE: 'add_to_home_screen_cross_click',
  ADD_TO_HOME_SCREEN_BACKGROUND_CLICK: 'add_to_home_screen_bg_click'
};
